import { List } from 'immutable';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';

import AlbumTrackListItem from './AlbumTrackListItem';

export const AlbumTrackList = props => {
  const validatePropKey = prop => {
    return !isNil(prop);
  };

  const generateListKey = () => {
    return [
      // when any of these values change, it will ensure BackstageItemList gets rerendered
      // so that the item's source card options get updated.
      props.albumPandoraId,
      props.isCompilation,
    ]
      .filter(validatePropKey)
      .join(':');
  };

  const generateListItemProps = (pandoraId, index) => {
    const currentTrack = props.tracks[index];

    return {
      trackProps: currentTrack,
      albumPandoraId: props.albumPandoraId,
      isCompilation: props.isCompilation,
      releaseType: props.releaseType,
    };
  };

  const tracksIdList = List(props.tracks.map(track => track.id));

  return (
    <D.BackstageItemList
      listKey={generateListKey()}
      sourceItems={tracksIdList}
      elementHeight={props.elementHeight}
      generateListItemProps={generateListItemProps}
      listItemComponent={AlbumTrackListItem}
    />
  );
};

AlbumTrackList.propTypes = {
  tracks: PropTypes.array,
  albumPandoraId: PropTypes.string,
  isCompilation: PropTypes.bool,
  releaseType: PropTypes.string,
  elementHeight: PropTypes.number,
};

export default AlbumTrackList;
